import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  SellarImportsInvoiceUpdateStatusRequestType,
  SellarImportsInvoiceUpdateStatusResponseType,
} from "@sellar-io/api-v2/types";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";

export const useSellarImportFeeInvoiceStatusUpdate = (params: {
  sellarImportPayoutId: number;
}) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SellarImportsInvoiceUpdateStatusRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `sellar-imports/finance/payouts/${params.sellarImportPayoutId}/fee-invoice/status`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as SellarImportsInvoiceUpdateStatusResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SellarImportsPayouts,
          params.sellarImportPayoutId,
        ],
      });
    },
  });
};
